import { render } from "./baremos.vue?vue&type=template&id=2386726b&scoped=true"
import script from "./baremos.vue?vue&type=script&lang=js"
export * from "./baremos.vue?vue&type=script&lang=js"

import "./baremos.vue?vue&type=style&index=0&id=2386726b&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2386726b"]])

export default __exports__